class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function (event) {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      if (this.closest('cart-items')) {
        const toast = document.querySelector('#toast-container.cart-confirmation-toast');

        const name = event.currentTarget.parentElement.parentElement.querySelector('.cart-item__name').innerText;
        const toastTextElement = toast.querySelector('.toast-copy > span');
        toastTextElement.innerText = toastTextElement.innerText.replace('{{ product_name }}', name);

        toast.show();
      }

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.bindCustom();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    // Don't run for size selector change
    if (event.target.classList.contains('grid-selector__input')) {
      return;
    }

    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-totals',
        section: document.getElementById('main-cart-totals').dataset.id,
        selector: '.totals__holder',
      },
      {
        id: 'MainContent',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart__cards-mobile',
      },
      {
        id: 'MainContent',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart__cards-desktop',
      },
    ];
  }

  restoreLastRemovedItem() {
    const items = [window.lastRemovedItem];
    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig(),
      ...{
        body: JSON.stringify({
          items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      },
    })
      .then((response) => response.json())
      .then(async (partialCartState) => {
        // Context from cart_add_url is not full and doesn't have all required fields
        const cartContext = await fetch(`${routes.cart_url}`, {
          ...fetchConfig(),
        }).then((resp) => resp.json());

        const line = window.lastRemovedItem.line;
        const name = window.lastRemovedItem.name;
        const variantId = window.lastRemovedItem.id;
        const parsedState = {
          ...partialCartState,
          ...cartContext,
        };

        this.renderCartFromParsedState(parsedState, line, name, variantId);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        const line = window.lastRemovedItem.line;
        this.disableLoading(line);
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    // If removing, store removed item info for undo
    if (quantity === 0) {
      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

      if (lineItem) {
        // selected line item won't be a select if we have only one item
        const selectedLineItem = lineItem.querySelector('.cart-item__quantity-select');
        const variantIdNum =
          selectedLineItem !== null
            ? parseInt(selectedLineItem.getAttribute('data-quantity-variant-id') || '', 10)
            : '';
        const name = lineItem.querySelector('.cart-item__name').innerText;
        // if there is only one item the qty is 1
        const qty = selectedLineItem !== null ? parseInt(selectedLineItem.value || '1', 10) : 1;

        window.lastRemovedItem = {
          line,
          name,
          id: variantIdNum,
          quantity: qty,
        };
      }
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderCartFromParsedState(parsedState, line, name, variantId);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  removeBuyStackModals() {
    // If size and color modal exist remove for every line item to allow rerendering (cart-edit-size.liquid) (cart-edit-color.liquid)
    Array.from(document.querySelectorAll('.cart-item__holder')).forEach((_, i) => {
      document.getElementById(`edit-cart-modal-size-${i + 1}`)?.remove();
      document.getElementById(`edit-cart-modal-color-${i + 1}`)?.remove();
    });
  }

  renderCartFromParsedState(parsedState, line, name, variantId) {
    const quantityElement =
      document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    this.removeBuyStackModals();

    if (parsedState.errors && quantityElement) {
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartTitle = document.querySelector('.cart-title-holder span');
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartSectionWrapper = document.querySelector('.cart-holder');
    const stickySectionWrapper = document.querySelector('.cart-sticky-checkout');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartSectionWrapper) cartSectionWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    if (stickySectionWrapper) stickySectionWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    if (cartTitle && parsedState.item_count != null) {
      const numberRegEx = /\d+/;
      const titleText = cartTitle.innerHTML;
      cartTitle.innerHTML = titleText.replace(numberRegEx, parsedState.item_count);
    }

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      let newInnerHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (newInnerHtml) {
        elementToReplace.innerHTML = newInnerHtml;
      } else {
        const targetedElementToReplace = document.getElementById(section.id).querySelector(section.selector);
        targetedElementToReplace.innerHTML = null;
      }
    });

    this.restoreCartDOMOrder();

    const updatedValue = parsedState?.items?.[line - 1] ? parsedState.items[line - 1].quantity : undefined;

    let message = '';
    if (items.length === parsedState?.items?.length && updatedValue !== parseInt(quantityElement?.value)) {
      if (typeof updatedValue === 'undefined') {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    //Update Sticky
    if (stickySectionWrapper) {
      const subtotalEl = document.querySelector('.price-line.totals__subtotal .price-line__amount');
      const targetEl = stickySectionWrapper.querySelector('.cart-sticky-checkout__total .price-line__value span');

      if (subtotalEl && targetEl) {
        targetEl.innerHTML = subtotalEl.innerHTML;
      }
    }

    this.setCartID();

    this.setOriginalCartOrder();

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
  }

  bindCustom() {
    document.addEventListener('cart:force-refresh', async (e) => {
      try {
        await this.itemReplace(e.detail);
      } catch (err) {
        console.error('Error in itemReplace:', err);
      }
    });

    // When item is replaced the order changes, that function saves original state to restore later
    this.setOriginalCartOrder();
  }

  async itemReplace({ lineIndex, originalVariantId, newVariantId, quantity, bottomSheetModal }) {
    const bodyConfig = {
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    await fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
        ...bodyConfig,
      }),
    });

    const addResponseText = await fetch(routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        id: newVariantId,
        quantity,
        ...bodyConfig,
      }),
    });

    const parsedState = await addResponseText.json();

    bottomSheetModal.close();

    this.updateItemsOrderState(originalVariantId, newVariantId);
    const focusedElement = document.activeElement.getAttribute('name');
    this.renderCartFromParsedState(parsedState, lineIndex, focusedElement, newVariantId);
  }

  restoreCartDOMOrder() {
    const parent = document.querySelector('.cart-items');
    if (!window.originalCartOrder || !parent) return;

    const holders = Array.from(parent.querySelectorAll('.cart-item__holder'));
    const map = new Map(
      holders.map((holder) => {
        const variantId = holder.querySelector('select[data-quantity-variant-id]')?.dataset.quantityVariantId;
        return [variantId, holder];
      })
    );

    const ordered = window.originalCartOrder.map((variantId) => map.get(variantId)).filter(Boolean);
    ordered.forEach((holder) => parent.appendChild(holder));
  }

  setOriginalCartOrder() {
    window.originalCartOrder = Array.from(document.querySelectorAll('.cart-item__holder'))
      .map((holder) => {
        const select = holder.querySelector('select[data-quantity-variant-id]');
        return select?.dataset.quantityVariantId;
      })
      .filter(Boolean);
  }

  updateItemsOrderState(originalVariantId, newVariantId) {
    const index = window.originalCartOrder.findIndex((variantId) => variantId === originalVariantId);
    if (index !== -1) window.originalCartOrder[index] = newVariantId + '';
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
